import Vue from 'vue';
import organizationMemberBookingTransformer from './../../transformers/organizationMemberBooking';

const success = (data, resolve) => {
  resolve(data);
};

const failed = (errors, reject) => {
  reject(errors.message);
};

export default organizationMemberBooking => (
  new Promise((resolve, reject) => {
    Vue.$http
      .put(`/organization_member_bookings/${organizationMemberBooking.id}`, organizationMemberBookingTransformer.send(organizationMemberBooking))
      .then((response) => {
        success(response.data, resolve);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/organizationMemberBooking/update.js